@if (clientenPage) {
  <zah-clienten-filter [zones]="zones"
    [diensten]="diensten"
    (newSearch)="onSearch($event)">
  </zah-clienten-filter>
  <mat-nav-list>
    <h3 class="subheader">
      Cliënten
      @if (!clientenPage.isEmpty()) {
        <zah-sort-button
          [sortOrder]="initialPageRequest.getSortOrder()"
          (sortOrderChange)="onSortOrderChange($event)">
        </zah-sort-button>
      }
    </h3>
    @for (client of clientenPage.getItems(); track client) {
      <mat-list-item (click)="onClientClick(client)"
        [class.archived]="client.isGearchiveerd()">
        <zah-avatar matListItemAvatar
          [color]="client.isGearchiveerd() ? 'disabled': 'primary'"
          [name]="client.getNaam()">
        </zah-avatar>
        <div matListItemTitle>{{ client.getNaam() }} <span class="mat-small">({{ client.getNummer() }})</span></div>
        <div matListItemLine class="mat-small">{{ client.getDiensten() | zahClientDiensten:diensten:zones }}</div>
        <button matListItemMeta mat-icon-button
          class="center-vertically"
          [disableRipple]="true"
          [matMenuTriggerFor]="menu"
          (click)="$event.stopPropagation()">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu"
          xPosition="before"
          overlapTrigger="true">
          <a mat-menu-item
            (click)="onMeldingenClicked(client)">
            <mat-icon fontSet="material-icons-outlined">contact_mail</mat-icon>
            <span>Meldingen</span>
          </a>
          <a mat-menu-item
            (click)="onPrestatiesClick(client)">
            <mat-icon fontSet="material-icons-outlined">fact_check</mat-icon>
            <span>Prestaties</span>
          </a>
          <a mat-menu-item
            (click)="onSignaalkaartenClick(client)">
            <mat-icon fontSet="material-icons-outlined">assignment</mat-icon>
            <span>Signaalkaarten</span>
          </a>
          <a mat-menu-item
            (click)="onWijzigClientClick(client)">
            <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
            <span>Cliënt wijzigen</span>
          </a>
          <a mat-menu-item
            (click)="onClientFicheClick(client)">
            <mat-icon fontSet="material-icons-outlined">description</mat-icon>
            <span>Cliëntfiche</span>
          </a>
          @if (!client.isGearchiveerd()) {
            <a
              mat-menu-item
              (click)="onArchiveClick(client)">
              <mat-icon fontSet="material-icons-outlined">archive</mat-icon>
              <span>Archiveren</span>
            </a>
          }
          @if (client.isGearchiveerd()) {
            <a
              mat-menu-item
              (click)="onUnarchiveClick(client)">
              <mat-icon fontSet="material-icons-outlined">unarchive</mat-icon>
              <span>Activeren</span>
            </a>
          }
        </mat-menu>
      </mat-list-item>
      <mat-divider></mat-divider>
    }
    @if (clientenPage.isEmpty()) {
      <mat-list-item
        class="no-list-item-highlight"
        disableRipple
        lines="2">
        <div matListItemTitle>Geen cliënten gevonden</div>
      </mat-list-item>
    }
    <mat-list-item class="no-list-item-highlight overflow-visible-for-button-shading"
      disableRipple
      lines="2">
      <span matListItemMeta class="center-vertically">
        <button mat-mini-fab
          color="accent"
          (click)="onAddClick()">
          <mat-icon>add</mat-icon>
        </button>
      </span>
    </mat-list-item>
  </mat-nav-list>
  <zah-paginator [currentPage]="clientenPage"
    [pageSize]="initialPageRequest.getPageSize()"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)">
  </zah-paginator>
}
